// extracted by mini-css-extract-plugin
module.exports = {"card":"NFTAssetGroup_card__1PgyK","main":"NFTAssetGroup_main__2b0l2","icon":"NFTAssetGroup_icon__1-4SM","link":"NFTAssetGroup_link__3h-Tc"};